import { Stack } from "@mui/material";
import type { FC, ReactNode } from "react";
import { DashboardSectionHeader } from "web_myplann/Dashboard/Components/DashboardSectionHeader";

type Props = {
	title: string;
	actionLabel?: string;
	onAction?: () => void;
	children: ReactNode;
};

export const DashboardSection: FC<Props> = ({
	title,
	actionLabel,
	onAction,
	children,
}) => (
	<Stack>
		<DashboardSectionHeader
			title={title}
			actionLabel={actionLabel}
			onAction={onAction}
		/>
		<Stack bgcolor="background.paper">{children}</Stack>
	</Stack>
);
